import React, { Component } from "react";
import { Link } from "react-router-dom";
import Radium from "radium";
import { Grid, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Filter from "../Filters/index";
import JobRow from "../JobRow";
import msgIcon from "../../../images/msg-icon.png";
import {
  getAppliedJobs as getAppliedJobsAction,
  searchJobs as searchJobsAction,
} from "../../../redux/middleware/job";
import Loader from "../../Shared/Loader";
import { styles } from "./style.ts";

const Jobs = ({ jobs, applied, pending }) => {
  if (pending) return <Loader vwidth="50vw" fullScreen show />;
  if (jobs.length === 0) return <p>No jobs found.</p>;
  return (
    <div>
      {jobs.map((job) => (
        <JobRow job={job} applied={applied} key={job.id} />
      ))}
    </div>
  );
};

class JobList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stateFilters: [],
    };
  }

  componentWillMount() {
    const { user, appliedJobs, jobs } = this.props;
    user && appliedJobs(user);
    jobs && !jobs.length && this.searchJobs();
  }

  componentDidMount() {
    const { filters } = this.props;
    filters && this.setState({ stateFilters: filters });
  }

  componentWillReceiveProps(nextProps) {
    const { user, appliedJobs, location } = this.props;
    const { stateFilters } = this.state;
    !user && nextProps.user && appliedJobs(nextProps.user);
    if (
      location.pathname !== nextProps.location.pathname ||
      location.search !== nextProps.location.search
    ) {
      this.searchJobs();
    }
    if (stateFilters && stateFilters.length <= 1) {
      this.setState({ stateFilters: nextProps.filters });
    }
  }

  searchJobs = (filters = null) => {
    const { searchJobs } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const keywords = urlParams.get("keywords") || "";
    const location = urlParams.get("location") || "";
    searchJobs(keywords, location, filters);
  };

  render() {
    const { jobs, applied, totalJobs, pending } = this.props;
    const { stateFilters } = this.state;

    return (
      <div>
        <Grid>
          <Row>
            <Col md={3}>
              <Filter
                filters={stateFilters}
                search={(filters) => this.searchJobs(filters)}
              />
            </Col>
            <Col md={9} className="clearfix">
              <Row>
                <Col xs={5} sm={7} md={8} lg={8} className="clearfix">
                  <div className="animated flipInX">
                    <h1 style={styles.h1} className="">
                      All Jobs
                    </h1>
                    <p style={styles.p} className="hidden-xs">
                      Displaying {jobs.length} out of {totalJobs} jobs
                    </p>
                  </div>
                </Col>
                <Col
                  xs={7}
                  sm={5}
                  md={4}
                  lg={4}
                  className="text-right clearfix"
                >
                  {false && (
                    <Link
                      to="#"
                      style={styles.button}
                      className="btn btn-primary btn-lg pull-right"
                    >
                      <img
                        style={{ marginRight: 10, fontWeight: 600 }}
                        src={msgIcon}
                        alt="Create Job Alert"
                      />
                      Create Job Alert
                    </Link>
                  )}
                </Col>
              </Row>
              <Row
                className="clearfix"
                style={{ position: "relative", top: -10, marginBottom: 60 }}
              >
                <Col lg={12} className="clearfix">
                  <Jobs
                    applied={
                      applied ? applied.map((applied) => applied.id) : []
                    }
                    jobs={jobs}
                    pending={pending}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  jobs: state.searchJobs.jobs,
  filters: state.searchJobs.filters,
  totalJobs: state.searchJobs.totalJobs,
  pending: state.searchJobs.pending,
  applied: state.appliedJobs.jobs,
  user: state.userByToken.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      searchJobs: searchJobsAction,
      appliedJobs: getAppliedJobsAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Radium(JobList));
